import React from "react";

const FooterLista = ({ onAdicionar, onClose, somenteVisualizacao }) => {
  return (
    <div className="footer-dependente p-3">
      {!somenteVisualizacao && (
        <button
          type="button"
          className="btn btn-outline-dark"
          onClick={onAdicionar}
        >
          <i className="fas fa-plus me-2" />
          Novo Dependente
        </button>
      )}

      <button type="button" className="btn btn-outline-dark" onClick={onClose}>
        <i className="fas fa-times me-2" />
        Voltar
      </button>
    </div>
  );
};

export default FooterLista;
